/**
 * Ссылка на текущую комнату — для тех, кто не внутри отрисовки.
 *
 * Комната живёт в `useCall`, и это правильно: её создаёт и разбирает экран.
 * Но статистика связи нужна из консоли, посреди разговора и без единой
 * перерисовки, — а до `roomRef` оттуда не дотянуться никак.
 *
 * Поэтому одна ссылка сбоку, которую `useCall` держит в согласии со своей.
 * Ничего, кроме чтения, отсюда не делается: подписываться на события и
 * разбирать комнату — по-прежнему его работа.
 */

import type { Room } from "livekit-client";

let held: Room | null = null;

export function holdRoom(room: Room | null): void {
  held = room;
}

export function heldRoom(): Room | null {
  return held;
}
